__turbopack_context__.v({
  "WebShareButton": "style-module-scss-module__SsFebW__WebShareButton",
});
